import { Type } from '../Type';
import { Integer } from './Integer';
export class Integer32 extends Integer {
    constructor(value) {
        super(Type.Integer32, value);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW50ZWdlcjMyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9udW1lcmljL0ludGVnZXIzMi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBRTlCLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFbkMsTUFBTSxPQUFPLFNBQVUsU0FBUSxPQUFlO0lBQzVDLFlBQVksS0FBYTtRQUN2QixLQUFLLENBQUMsSUFBSSxDQUFDLFNBQVMsRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUM5QixDQUFDO0NBQ0YifQ==